import { GetTypesResponse, Type } from "../../../api/types/getTypes";

export const separateLanguageAndKnowledge = (data: GetTypesResponse) => {
  const language: Type[] = [];
  const knowledge: Type[] = [];

  data?.mapped.forEach((d) => {
    const isLanguageGroup = d.label.toLowerCase() === "språk";

    if (isLanguageGroup) language.push(d);
    else knowledge.push(d);
  });

  return [language, knowledge];
};
